import { Component, AfterViewInit } from '@angular/core';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { SysGlobals } from '@core/framework/sysglobals';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';


@Component({
    providers: ServiceBagServices,
    selector: 'm4u-sessionexpire',
    templateUrl: './sessionexpire.component.html',
    styleUrls: ['./sessionexpire.component.scss']
})
export class SessionExpireComponent extends BasePageComponent<BaseEntity, BaseState> implements AfterViewInit {

    constructor(A: ServiceBagService,
        private sidebarService: SidebarService) {
        super(A, 'SessionExpireComponent', BaseEntity, BaseState);
    }


    override ngAfterViewInit() {
        this.sidebarService.ClearSidebars();
        setTimeout(() => { this.Navigate(['/system/login'], { Language: SysGlobals.Language }); }, 2000);
    }
}
